// Tipos e constantes compartilhados pelos sub-componentes de Atividades.

export interface Atividade {
  id: string;
  titulo: string;
  descricao: string | null;
  tipo: string;
  status: 'pendente' | 'em_andamento' | 'concluida' | 'cancelada';
  prioridade: 'baixa' | 'media' | 'alta' | 'urgente';
  data_vencimento: string | null;
  data_conclusao: string | null;
  origem_modulo: string | null;
  origem_tipo: string | null;
  origem_id: string | null;
  origem_label: string | null;
  referencia_id: string | null;
  criado_por: string;
  criado_em: string;
  atualizado_em: string;
  atribuicoes: { email: string; papel: string }[];
}

export interface AtividadesProps {
  moduloFixo?: 'comercial' | 'operacional' | 'administrativo' | 'financeiro' | 'pessoal';
  origemModulo?: string;
  origemId?: string;
  origemLabel?: string;
  onIrParaOrigem?: (modulo: string, origemTipo: string, origemId: string, referenciaId: string | null) => void;
}

export const COR_MODULO: Record<string, { bg: string; cor: string; emoji: string; label: string; tagColor: string }> = {
  comercial:      { bg: '#EFF3FF', cor: '#0930D0', emoji: '🤝', label: 'Comercial',      tagColor: 'blue' },
  operacional:    { bg: '#E8F5EE', cor: '#0a7f4a', emoji: '⚙️', label: 'Operacional',    tagColor: 'green' },
  administrativo: { bg: '#F3E8FF', cor: '#7C3AED', emoji: '📦', label: 'Administrativo', tagColor: 'purple' },
  financeiro:     { bg: '#FFF8E8', cor: '#7A5500', emoji: '📊', label: 'Financeiro',     tagColor: 'gold' },
  marketing:      { bg: '#F1ECFD', cor: '#7C3AED', emoji: '📱', label: 'Marketing',      tagColor: 'magenta' },
  pessoal:        { bg: '#F2F2F4', cor: '#555',    emoji: '👤', label: 'Pessoal',        tagColor: 'default' },
};

export const STATUS_LABEL: Record<string, { label: string; cor: string; bg: string; tagColor: string }> = {
  pendente:      { label: 'Pendente',     cor: '#B07500', bg: '#FFF8E8', tagColor: 'gold' },
  em_andamento:  { label: 'Em andamento', cor: '#0930D0', bg: '#EFF3FF', tagColor: 'blue' },
  concluida:     { label: 'Concluída',    cor: '#0a7f4a', bg: '#E8F5EE', tagColor: 'green' },
  cancelada:     { label: 'Cancelada',    cor: '#888',    bg: '#F2F2F4', tagColor: 'default' },
};

export const PRIORIDADE_LABEL: Record<string, { label: string; cor: string }> = {
  baixa:   { label: 'Baixa',   cor: '#888' },
  media:   { label: 'Média',   cor: '#0930D0' },
  alta:    { label: 'Alta',    cor: '#B07500' },
  urgente: { label: 'Urgente', cor: '#B91626' },
};

export const TIPOS = ['tarefa', 'ligacao', 'email', 'reuniao', 'nota', 'prazo'];
